export const reconcileFinalBotMessage = (lastMessage, responseMessage) => {
  if (!responseMessage) return lastMessage;
  if (!lastMessage || lastMessage.sender !== "bot") return responseMessage;

  const preservedRuntimeFields = {};
  if (lastMessage.__stableKey) {
    preservedRuntimeFields.__stableKey = lastMessage.__stableKey;
  }
  if (lastMessage.__localKey) {
    preservedRuntimeFields.__localKey = lastMessage.__localKey;
  }

  const streamedText = typeof lastMessage.message === "string"
    ? lastMessage.message
    : "";
  const finalText = typeof responseMessage.message === "string"
    ? responseMessage.message
    : "";

  if (streamedText === finalText) {
    return {
      ...lastMessage,
      ...responseMessage,
      ...preservedRuntimeFields,
      message: streamedText,
    };
  }

  if (streamedText && finalText.startsWith(streamedText)) {
    return {
      ...lastMessage,
      ...responseMessage,
      ...preservedRuntimeFields,
      message: streamedText,
    };
  }

  return {
    ...lastMessage,
    ...responseMessage,
    ...preservedRuntimeFields,
  };
};
